import { render, staticRenderFns } from "./confirmDeletionResaleModal.vue?vue&type=template&id=710c57ec&"
import script from "./confirmDeletionResaleModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionResaleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports